/**
 * Check a page for js-youtube elements and load them trough the Youtube API
 *
 * @since 1.0.0
 */

/* global YT */

const videos = document.querySelectorAll('.js-youtube')
const players = []

const YoutubeVideos = function() {
  if (videos.length) {
    loadYoutubeApi()
  }
}

function loadYoutubeApi() {
  var tag = document.createElement('script')
  tag.src = 'https://www.youtube.com/iframe_api'
  var firstScriptTag = document.getElementsByTagName('script')[0]
  firstScriptTag.parentNode.insertBefore(tag, firstScriptTag)
}

window.onYouTubeIframeAPIReady = function() {
  ;[...videos].forEach(el => {
    const { id, iframe } = el.dataset
    if (id && iframe) {
      new YT.Player(iframe, {
        height: '390',
        width: '640',
        videoId: id,
        playerVars: {
          rel: 0,
          showinfo: 0,
          autohide: 1,
          playsinline: 1,
          html5: 1,
          modestbranding: 1
        }
      })
    }
  })
}

export default YoutubeVideos



// WEBPACK FOOTER //
// ./src/js/modules/Youtube.js